import {
  z,
  zCalendarDate,
  zCoercedBoolean,
  zDecimalNullable,
} from '@harvestiq/zod';
import { LgmCampaignPdfColumns, RmaLgmTypeCodes } from '@harvestiq/constants';

export const getLgmQuoteAndPdfParamsSchema = z.object({
  typeCode: z.nativeEnum(RmaLgmTypeCodes),
  targetSalesEffectiveDate: zCalendarDate(),
  deductibles: z.array(z.coerce.number().int().min(0).max(150)),
  feederCattleTargetCwtPerHead: zDecimalNullable().optional(),
  liveCattleTargetCwtPerHead: zDecimalNullable().optional(),
  cornTargetBuPerHead: zDecimalNullable().optional(),
  marketingMonths: z.array(z.coerce.number()),
  isPre2026BeginningFarmerRancher: zCoercedBoolean().optional(),
  isVeteranFarmerRancher: zCoercedBoolean().optional(),
  beginningFarmerRancherCropYearCount: z.coerce
    .number()
    .int()
    .nullable()
    .optional(),
  quoteColumns: z.array(z.nativeEnum(LgmCampaignPdfColumns)).optional(),
  logoUrl: z.string().url(),
  orgId: z.string(),
  campaignId: z.string().uuid().optional(),
});
export type GetLgmQuoteAndPdfParams = z.infer<
  typeof getLgmQuoteAndPdfParamsSchema
>;
